import { AlertTriangle, Clock, UserX, CheckCircle2, Timer, Layers } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { themedHex } from "@/lib/format";

function Tile({ label, value, sub, color, glow, icon: Icon, testid }) {
  const { theme } = useTheme();
  const c = themedHex(color, theme);
  return (
    <div className={`glass rounded-xl px-4 py-3.5 relative overflow-hidden ${glow}`} data-testid={testid}>
      <div className="flex items-start justify-between">
        <span className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground font-mono">{label}</span>
        {Icon && <Icon className="w-4 h-4" style={{ color: c }} />}
      </div>
      <div className="mt-2 font-mono font-medium text-4xl md:text-5xl tracking-tight glow-num tnum" style={{ color: c }}>{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-0.5 font-mono">{sub}</div>}
    </div>
  );
}

export default function KpiTiles({ k }) {
  if (!k) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
      <Tile testid="kpi-open" label="Open (counted)" value={k.open_total} icon={Layers} color="#22D3EE" glow="glass-cyan" sub="in-summary lanes" />
      <Tile testid="kpi-red" label="Red / Alert" value={k.red} icon={AlertTriangle} color="#EF4444" sub="past threshold" />
      <Tile testid="kpi-yellow" label="Yellow" value={k.yellow} icon={Clock} color="#EAB308" sub="approaching" />
      <Tile testid="kpi-stale" label="Stale" value={`${k.stale_rate}%`} icon={Timer} color="#64748B" sub={`${k.stale} · 7d+ no note`} />
      <Tile testid="kpi-unassigned" label="Unassigned" value={`${k.unassigned_rate}%`} icon={UserX} color="#F59E0B" sub={`${k.unassigned} open`} />
      <Tile
        testid="kpi-completed"
        label="Completed Rate"
        value={k.completed_rate == null ? "—" : `${k.completed_rate}%`}
        icon={CheckCircle2}
        color="#34D399"
        glow="glass-violet"
        sub={`n=${k.completed_rate_denominator} · med ${k.median_cycle_biz ?? "—"}d`}
      />
    </div>
  );
}
